<template>
  <div v-if="editable" class="custom-row-edit">
    <!-- v-model 绑定当前数据对象的字段名 -->
    <el-input v-model="data" class="edit-input" size="small" v-bind="$attrs" ref="input" />
    <i class="el-icon-check" @click.stop.prevent="save"></i>
    <i class="el-icon-close" @click.stop.prevent="close"></i>
  </div>
  <div v-else class="custom-row-edit">
    <span class="label">{{ data }}</span>
    <i class="el-icon-edit-outline icon" @click="edit"></i>
  </div>
</template>
<script>
    export default{
        name: 'InlineEditableInput',
        props: {
            value: [Number, String],
        },
        data() {
            return {
                editable : false,
                data: ''
            }
        },
        created () {
            this.data = this.value
        },
        watch : {
            value () {
                console.log(this.value, this.data);
                this.data = this.value
            }
        },
        methods: {
            edit() {
                this.editable = true;
                this.$nextTick(() => {
                    this.$refs.input.focus()
                })

            },
            close() {
                this.data = this.value;
                this.editable = false
            },
            save() {
                this.$emit('input', this.data);
                this.editable = false
            }
        }
    }
</script>
